import React from 'react';

const AppWrap = (Component, idName) => function highOrderComponent() {
    return (
        <section id={idName} className={`app__container`}>
            <div className='app__wrapper app__flex'>
                <Component />
            </div>
        </section>
    )
};

export default AppWrap;
